<template>
  <span class="icon-button" :class="{ 'icon-button--disabled': disabled }">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.icon-button {
  color: white;
  display: inline-flex;
  background-color: var(--coral);
  width: 25px;
  height: 25px;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
}

.icon-button:hover {
  background-color: var(--reddish);
}

.icon-button--disabled {
  display: none;
}
</style>
